<clr-main-container>
    <app-header title="New Driver"></app-header>

    <div class="content-container">
        <div class="content-area">

            <h2>Create Driver</h2>

            <form clrForm>
                <clr-input-container>
                    <label>Name</label>
                    <input clrInput type="text" [(ngModel)]="item['name']" name="Example Driver" />
                </clr-input-container>
                <button class="btn btn-primary" type="submit" [disabled]="!item['name']" (click)="submit()">
                    Submit
                </button>
            </form>


        </div>
    </div>
</clr-main-container>